/* KENT editorial motion: fade-and-rise on scroll. Skipped entirely for reduced-motion visitors. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || (reduce && reduce.matches)) return;

  var root = document.documentElement;
  root.classList.add('kent-motion');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  function watch(scope) {
    (scope || document).querySelectorAll('[data-kent-reveal]:not(.is-revealed)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watch(); });
  } else {
    watch();
  }

  // Theme editor: re-watch sections when they are added or re-rendered.
  document.addEventListener('shopify:section:load', function (event) { watch(event.target); });

  if (reduce && reduce.addEventListener) {
    reduce.addEventListener('change', function (event) {
      if (!event.matches) return;
      root.classList.remove('kent-motion');
      document.querySelectorAll('[data-kent-reveal]').forEach(function (el) { el.classList.add('is-revealed'); });
    });
  }
})();

/* Cart drawer side panel: a dimmed backdrop behind it; clicking it closes the cart. */
(function () {
  function init() {
    var drawer = document.querySelector('.cart-drawer');
    if (!drawer || document.querySelector('.kent-cart-scrim')) return;
    var scrim = document.createElement('div');
    scrim.className = 'kent-cart-scrim';
    scrim.setAttribute('aria-hidden', 'true');
    scrim.addEventListener('click', function () {
      var close = drawer.querySelector('.cart-close');
      if (close) close.click();
    });
    drawer.parentNode.insertBefore(scrim, drawer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ---------- Bundle savings tracker (product page + cart) ----------
   Liquid renders the right state from the cart; this keeps every tracker on the
   page in step when the cart changes, and re-applies after the cart drawer re-renders. */
(function () {
  if (!document.querySelector('[data-kent-bundle-tracker]') && !document.querySelector('.cart-drawer')) return;
  var tiers = [[3, 5], [5, 10], [7, 14]];
  var lastQ = null;
  function pairs(n) { return n + (n === 1 ? ' more pair' : ' more pairs'); }

  function paint(box, q) {
    // only touch the DOM when the count changed, so the drawer observer below can't loop
    if (box.getAttribute('data-kbt-q') === String(q)) return;
    box.setAttribute('data-kbt-q', String(q));
    var msg = box.querySelector('[data-kbt-msg]');
    var saving = 0, next = null;
    tiers.forEach(function (t) { if (q >= t[0]) saving = t[1]; else if (!next) next = t; });
    var html;
    if (q === 0) html = box.getAttribute('data-start');
    else if (!next) html = 'You’re saving <strong>' + saving + '%</strong> on your bundle';
    else if (!saving) html = 'Add <strong>' + pairs(next[0] - q) + '</strong> to save ' + next[1] + '%';
    else html = 'You’re saving ' + saving + '% · add <strong>' + pairs(next[0] - q) + '</strong> to save ' + next[1] + '%';
    if (msg) msg.innerHTML = html;
    [].forEach.call(box.querySelectorAll('[data-kbt-step]'), function (s) {
      var n = +s.getAttribute('data-kbt-step');
      s.classList.toggle('is-filled', n <= q);
      s.classList.toggle('is-reached', n <= q && s.classList.contains('is-tier'));
    });
    box.classList.toggle('is-complete', !next);
  }
  function paintAll() {
    if (lastQ === null) return;
    [].forEach.call(document.querySelectorAll('[data-kent-bundle-tracker]'), function (b) { paint(b, lastQ); });
  }

  var _fetch = window.fetch.bind(window);
  var pending;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      var box = document.querySelector('[data-kent-bundle-tracker]');
      if (!box) return;
      var handles = (box.getAttribute('data-handles') || '').split(',').filter(Boolean);
      _fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var q = 0;
          (cart.items || []).forEach(function (i) { if (handles.indexOf(i.handle) > -1) q += i.quantity; });
          lastQ = q;
          paintAll();
        })
        .catch(function () {});
    }, 150);
  }

  var cartUrl = /\/cart\/(add|change|update|clear)/;
  window.fetch = function (input) {
    var p = _fetch.apply(window, arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (cartUrl.test(url)) p.then(refresh, refresh);
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (cartUrl.test(url || '')) this.addEventListener('loadend', refresh);
    return _open.apply(this, arguments);
  };
  // the theme re-renders the cart drawer after changes; repaint any fresh tracker
  var drawer = document.querySelector('.cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    var queued = false;
    new MutationObserver(function (list) {
      // ignore changes made inside a tracker (our own repaint)
      var outside = list.some(function (m) { return !(m.target.closest && m.target.closest('[data-kent-bundle-tracker]')); });
      if (!outside || queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; paintAll(); });
    }).observe(drawer, { childList: true, subtree: true });
  }
  refresh();
})();
